<template>
  <pdf-a4-page no-margin :pdf-key="lang">
    <div class="landingpage-background w-screen h-screen">
      <div class="flex flex-col justify-between" style="height: 1020px">
        <div class="flex justify-between">
          <div class="text-3xl md:text-3xl">Checkliste BE Flächen</div>
          <div>
            <img src="../../../../public/assets/img/pdf/transnetBW/tng-logo.png" width="200"/>
          </div>
        </div>
        <div class="content">
          <div class="h-full max-h-full">
            <div class="grid grid-cols-8 justify-items-stretch items-center">
              <div class="text-sm font-bold col-span-3 border-solid rounded-md whiteYellowBorderColor">Vorhaben</div>
              <div class="text-sm font-bold col-span-3 border-solid rounded-md whiteYellowBorderColor">Aufnahmedaten</div>
              <div class="col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor">Mast-Foto</div>
              <div class="text-xs ml-2">Vorhaben:</div>
              <div class="text-gray-500 col-span-2 text-xs">
                {{ useIdentifierFrageFinder(ba, 'tng-be-fleachen.allgemein-tab.allgemein-group.vorhaben')?.['eingabeText'] }}
              </div>
              <div class="text-xs ml-2">BearbeiterIn:</div>
              <div class="text-gray-500 text-xs col-span-2">
                {{ useIdentifierFrageFinder(ba, 'tng-be-fleachen.allgemein-tab.allgemein-group.bearbeiter')?.['eingabeText'] }}
              </div>
              <div v-if="getPhotoUrl(immobilie?.vorschaubild)" class="mt-2 row-span-5 col-span-2">
               <img
                  :src="getPhotoUrl(immobilie?.vorschaubild)"
                  style="max-height: 150px"
                  height="150"
                  width="180"
                  data-cy="generalData-vorschaubild"
                />
              </div>
              <div v-else class="row-span-5 col-span-2 flex item-stretch justify-center items-center mt-2 no-pic">
                <p class="text-xs text-center self-center">Kein Bild hinzugefügt</p>
              </div>
              <div class="text-xs ml-2 ">Anlage:</div>
              <div class="text-gray-500 text-xs col-span-2">
                {{ useIdentifierFrageFinder(ba, 'tng-be-fleachen.allgemein-tab.allgemein-group.anlage')?.['eingabeText'] }}
              </div>
              <div class="text-xs ml-2">Firma:</div>
              <div class="text-gray-500 col-span-2 text-xs">
                {{ useIdentifierFrageFinder(ba,'tng-be-fleachen.allgemein-tab.allgemein-group.firma')?.['eingabeText'] }}
              </div>
              <div class="text-xs ml-2">Mastnr:</div>
              <div class="text-gray-500 text-xs col-span-2">
                {{ useIdentifierFrageFinder(ba, 'tng-be-fleachen.allgemein-tab.allgemein-group.mastnummer')?.['eingabeText'] }}
              </div>
              <div class="text-xs col-span-2 ml-2">Begehungsdatum:</div>
              <div class="text-gray-500 text-xs">
                {{ moment(useIdentifierFrageFinder(ba, 'tng-be-fleachen.allgemein-tab.allgemein-group.begehungsdatum')?.['eingabeText'] || "").isValid() 
                  ? moment(useIdentifierFrageFinder(ba, 'tng-be-fleachen.allgemein-tab.allgemein-group.begehungsdatum')?.['eingabeText']).format('DD-MM-YYYY') 
                  : "" 
                }}
              </div>
              <div class="text-xs ml-2" >
                Masttyp:
              </div>
              <div class="text-gray-500 text-xs col-span-2">
                {{ getAuswahlLabel(ba, 'tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.masttyp') }}
              </div>
              <div class="text-xs ml-2 col-span-2">Aktualisierungsdatum:</div>
              <div class="text-gray-500 text-xs">
                {{ ba?.updatedAt ? moment(ba.updatedAt).format('DD-MM-YYYY') : "" }}
              </div>
              <div class="text-xs ml-2">Höhe:</div>
              <div class="text-gray-500 text-xs col-span-2">
                {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.masthoehe')?.['eingabeText'] ? useIdentifierFrageFinder(ba, 'tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.masthoehe')?.['eingabeText'] + " m" : "-" }}
              </div>
              <div class="text-xs col-span-2 ml-2">Bearbeitungsstatus:</div>
              <div class="text-gray-500 text-xs col-span-1">
                  {{ statusReadable }}
              </div>
              <div class="text-xs ml-2">Mastbild:</div>
              <div class="text-gray-500 text-xs col-span-7">
                {{ getAuswahlLabel(ba, 'tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.mastbild') }}
              </div>
              <div class="text-xs ml-2">Gestängetyp:</div>
               <div class="text-gray-500 text-xs col-span-7">
                {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.gestaengetyp')?.['eingabeText'] }}
              </div>
              <div class="text-xs ml-2 col-span-2 mt-3">
                Baumaßnahme Art:
              </div>
              <div class="text-gray-500 text-xs col-span-6 mt-3">
              {{ getAuswahlLabel(ba,'tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.baumassnahmeart') }}
              </div>

              <is-vorhanden-char-and-label :ba="ba" fragesPath="tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.seilzug-vorhanden" label="Seilzug vorhanden" class="col-span-8 ml-2 mt-3"/>
                
              <is-vorhanden-char-and-label :ba="ba" fragesPath="tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.sonstiges-vorhanden" label="Sonstiges:" class="text-xs ml-2 mt-3"/>
              <div class="text-xs col-span-2 text-gray-500 mt-3">
                {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.sonstiges-beschreibung')?.['eingabeText'] }}
              </div>
              

              <is-vorhanden-char-and-label :ba="ba" fragesPath="tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.zus-massnahmen-vorhanden" label="Zusätzliche Maßnahmen:" class="col-span-2 ml-2 mt-3"/>
              <div class="text-xs col-span-3 text-gray-500 mt-3">
                {{ useIdentifierFrageFinder(ba, 'tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.zus-massnahmen-beschreibung')?.['eingabeText'] }}
              </div>
              <div class="text-xs col-span-1 ml-2 mt-3">Art:</div>
              <div class="text-xs col-span-7 mt-3">
                <div 
                  v-for="(v,key) in useIdentifierFrageFinder(ba,'tng-be-flaechen.allgemein-tab.geplante-baumassnahme-group.zus-massnahmen-art')?.getSelectedAuswahlLabels()" :key="key"
                  class="text-xs text-gray-500"
                >
                  {{v.de}}
                </div>
              </div>
              <div class="text-xs ml-2 col-span-2 mt-3">Unterzeichnet von:</div>
              <div class="text-xs col-span-4 row-span-2 mb-10 mt-3">
                <div class="col-span-3 text-gray-500 row-span-1">
                  {{ ba?.unterschrifts?.[0]?.name || '' }}
                </div>
                <div v-if="ba?.unterschrifts?.[0]?.bild && getPhotoUrl(ba.unterschrifts[0].bild)" class="h-2 text-xs col-span-3">
                <img
                    :src="getPhotoUrl(ba?.unterschrifts[0].bild)"
                    style="
                      max-height: 50px;
                      max-width: 180px;
                      background: #efefef;
                    "
                    height="50"
                    width="180"
                  />
                </div>
                <div
                  v-else
                  class="h-2 text-xs ml-2 col-span-3 flex item-stretch justify-center items-center"
                  style="
                    height: 50px;
                    max-height: 50px;
                    background-color: rgb(235, 239, 240);
                    border-radius: 5px;
                    border-style: solid;
                    border-color: rgb(235, 239, 240) rgb(235, 239, 240)
                      rgb(235, 239, 240) rgb(235, 239, 240);
                  "
                >
                  <p class="text-xs text-center self-center">keine Unterschrift hinzugefügt</p>
                </div>
              </div>
            </div>
<!-- RESULTS-->
            <div class="mt-6 flex justify-between border-solid rounded-md whiteYellowBorderColor">
              <div class="text-xl md:text-xl font-bold">Gesamt-Bewertung</div>
              <div>
                <PdfChip
                  :color="colorOverall"
                  mangel-amount-mode
                  :value="amountOverall"
                  pdf-mode
                />
              </div>
            </div>
            <div class="mt-2 ml-2 text-xs">
              Bewertung der BearbeiterIn:
              <span class="text-xs text-gray-500">{{ ba?.fazit }}</span>
            </div>
<!-- RESULTS Arbeitsfläche-->
            <div class="mt-6 flex justify-between border-solid rounded-md whiteYellowBorderColor">
              <div class="text-lg md:text-lg">Arbeitsfläche</div>
              <div class="place-self-center" v-if="getAuswahlLabel(ba, 'tng-be-flaechen.arbeitsflaeche-mast-tab.ergebnis-group.ergebnisbauflaechen')?.length > 0">
                {{ getAuswahlLabel(ba,'tng-be-flaechen.arbeitsflaeche-mast-tab.ergebnis-group.ergebnisbauflaechen') }}
              </div>
              <div v-else>keine Bewertung bisher</div>
              <div>
                <PdfChip
                  :color="colorArbeitsFlaechen"
                  mangel-amount-mode
                  :value="amountArbeitsFlaechen"
                  big
                  pdf-mode
                />
              </div>
            </div>
            <div class="p-2 grid grid-cols-8 gap-1 justify-item-stretch">
              <div class="col-span-4 text-sm ml-1">Allgemeine Punkte:</div>
              <div class="justify-self-end">
                <PdfChip
                  color="green"
                  mangel-amount-mode
                  :value="
                    Object?.values(
                      getArbeitsFlaecheBewertungen(ba)['allgemein']
                    )?.filter((f) => f === 'plus')?.length
                  "
                  pdf-mode
                />
              </div>
              <div class="justify-self-end">
                <PdfChip
                  color="blue"
                  mangel-amount-mode
                  :value="
                    Object?.values(
                      getArbeitsFlaecheBewertungen(ba)['allgemein']
                    )?.filter((f) => f === 'o')?.length
                  "
                  pdf-mode
                />
              </div>
              <div class="justify-self-end">
                <PdfChip
                  color="yellow"
                  mangel-amount-mode
                  :value="
                    Object?.values(
                      getArbeitsFlaecheBewertungen(ba)['allgemein']
                    )?.filter((f) => f === 'minus')?.length
                  "
                  pdf-mode
                />
              </div>
              <div class="justify-self-end">
                <PdfChip
                  color="red"
                  mangel-amount-mode
                  :value="
                    Object?.values(
                      getArbeitsFlaecheBewertungen(ba)['allgemein']
                    )?.filter((f) => f === 'x')?.length
                  "
                  pdf-mode
                />
              </div>
              <div class="col-span-4 text-sm ml-1">Geländebeschaffenheit:</div>
              <div class="justify-self-end">
                <PdfChip
                  color="green"
                  mangel-amount-mode
                  :value="
                    Object?.values(
                      getArbeitsFlaecheBewertungen(ba)['gelaende']
                    )?.filter((f) => f === 'plus')?.length
                  "
                  pdf-mode
                />
              </div>
              <div class="justify-self-end">
                <PdfChip
                  color="blue"
                  mangel-amount-mode
                  :value="
                    Object?.values(
                      getArbeitsFlaecheBewertungen(ba)['gelaende']
                    )?.filter((f) => f === 'o')?.length
                  "
                  pdf-mode
                />
              </div>
              <div class="justify-self-end">
                <PdfChip
                  color="yellow"
                  mangel-amount-mode
                  :value="
                    Object?.values(
                      getArbeitsFlaecheBewertungen(ba)['gelaende']
                    )?.filter((f) => f === 'minus')?.length
                  "
                  pdf-mode
                />
              </div>
              <div class="justify-self-end">
                <PdfChip
                  color="red"
                  mangel-amount-mode
                  :value="
                    Object?.values(
                      getArbeitsFlaecheBewertungen(ba)['gelaende']
                    )?.filter((f) => f === 'x')?.length
                  "
                  pdf-mode
                />
              </div>
              <div class="col-span-4 text-sm ml-1">Ökologie:</div>
              <div class="justify-self-end">
                <PdfChip
                  color="green"
                  mangel-amount-mode
                  :value="
                    Object?.values(
                      getArbeitsFlaecheBewertungen(ba)['oekologie']
                    )?.filter((f) => f === 'plus')?.length
                  "
                  pdf-mode
                />
              </div>
              <div class="justify-self-end">
                <PdfChip
                  color="blue"
                  mangel-amount-mode
                  :value="
                    Object?.values(
                      getArbeitsFlaecheBewertungen(ba)['oekologie']
                    )?.filter((f) => f === 'o')?.length
                  "
                  pdf-mode
                />
              </div>
              <div class="justify-self-end">
                <PdfChip
                  color="yellow"
                  mangel-amount-mode
                  :value="
                    Object?.values(
                      getArbeitsFlaecheBewertungen(ba)['oekologie']
                    )?.filter((f) => f === 'minus')?.length
                  "
                  pdf-mode
                />
              </div>
              <div class="justify-self-end">
                <PdfChip
                  color="red"
                  mangel-amount-mode
                  :value="
                    Object?.values(
                      getArbeitsFlaecheBewertungen(ba)['oekologie']
                    )?.filter((f) => f === 'x')?.length
                  "
                  pdf-mode
                />
              </div>
            </div>
<!-- RESULTS Zuwegung-->
            <div class="flex justify-between border-solid rounded-md whiteYellowBorderColor">
              <div class="text-lg md:text-lg">Zuwegung</div>
              <div>
                <div v-if="getAuswahlLabel(ba, 'tng-be-flaechen.zuwegung-mast-tab.ergebnis-group.ergebniszuwegung')?.length > 0" class="place-self-center">
                  {{ getAuswahlLabel(ba, 'tng-be-flaechen.zuwegung-mast-tab.ergebnis-group.ergebniszuwegung') }}
                </div>
                <div v-else>keine Bewertung bisher</div>
              </div>
              <div>
                <PdfChip
                  :color="colorZuwegung"
                  mangel-amount-mode
                  :value="amountZuwegung"
                  big
                  pdf-mode
                />
              </div>
            </div>
            <div class="p-2 grid grid-cols-8 gap-2 w-fit">
              <div class="col-span-4 text-sm ml-2">Allgemeine Punkte:</div>
              <div class="justify-self-end">
                <PdfChip
                  color="green"
                  mangel-amount-mode
                  :value="
                    Object?.values(getZuwegungBewertungen(ba))
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'plus';
                      })?.length
                  "
                  pdf-mode
                />
              </div>
              <div class="justify-self-end">
                <PdfChip
                  color="blue"
                  mangel-amount-mode
                  :value="
                    Object?.values(getZuwegungBewertungen(ba))
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'o';
                      })?.length
                  "
                  pdf-mode
                />
              </div>
              <div class="justify-self-end">
                <PdfChip
                  color="yellow"
                  mangel-amount-mode
                  :value="
                    Object?.values(getZuwegungBewertungen(ba))
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'minus';
                      })?.length
                  "
                  pdf-mode
                />
              </div>
              <div class="justify-self-end">
                <PdfChip
                  color="red"
                  mangel-amount-mode
                  :value="
                    Object?.values(getZuwegungBewertungen(ba))
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'x';
                      })?.length
                  "
                  pdf-mode
                />
              </div>
            </div>


          </div>
        </div>
        <be-footer
          :ba="ba"
          :immobilie="immobilie"
          :lang="lang"
          class=""
        />
      </div>
    </div>
  </pdf-a4-page>
  <pdf-a4-page no-margin :pdf-key="lang">
    <div class="landingpage-background w-screen h-screen">
      <div class="flex flex-col justify-between" style="height: 1020px">
        <div class="flex justify-between">
          <div class="text-3xl md:text-3xl">Checkliste BE Flächen</div>
          <div>
            <img
              src="../../../../public/assets/img/pdf/transnetBW/tng-logo.png"
              width="200"
            />
          </div>
        </div>
        <div class="content">
          <div class="h-full max-h-full">
<!-- RESULTS Seilzugfläche-->
            <div v-for="(seilzugflaeche, szfKey) in getSeilzugflaechen(ba)" :key="szfKey">
              <div class="mt-6 flex justify-between" style="border-style: solid; border-color: white white rgb(216, 215, 26) white; border-radius: 5px;">
                <div class="text-lg md:text-lg">Seilzugfläche {{szfKey + 1}}</div>
                <div class="text-xs" >{{ seilzugflaeche.findFrageByRelativePath(ba,'ergebnis-modal.ergebnis.seilzugflaeche')?.getSelectedAuswahlLabelsString() }}</div>
                <div class="text-xs" >Zuwegung {{ seilzugflaeche.findFrageByRelativePath(ba,'ergebnis-modal.ergebnis.ergebniszuwegung')?.getSelectedAuswahlLabelsString() }}</div>
                <div class="justify-self-end">
                  <PdfChip
                    :color="summarizeSeilzugflaecheBewertungen(ba,seilzugflaeche)['color']"
                    mangel-amount-mode
                    :value="summarizeSeilzugflaecheBewertungen(ba,seilzugflaeche)['amount']"
                    pdf-mode
                  />
                </div>
              </div>
              <div class="p-2 grid grid-cols-8 gap-1 justify-item-stretch">
                <div class="col-span-4 text-sm ml-1">Seilzugfläche:</div>
                <div class="justify-self-end">
                  <PdfChip
                    color="green"
                    mangel-amount-mode
                    :value="
                      Object?.values(getSeilzugflaecheBewertungen(ba,seilzugflaeche)['seilzugflaeche'])
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'plus';
                        })?.length
                    "
                    pdf-mode
                  />
                </div>
                <div class="justify-self-end">
                  <PdfChip
                    color="blue"
                    mangel-amount-mode
                    :value="
                      Object?.values(getSeilzugflaecheBewertungen(ba,seilzugflaeche)['seilzugflaeche'])
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'o';
                        })?.length
                    "
                    pdf-mode
                  />
                </div>
                <div class="justify-self-end">
                  <PdfChip
                    color="yellow"
                    mangel-amount-mode
                    :value="
                      Object?.values(getSeilzugflaecheBewertungen(ba,seilzugflaeche)['seilzugflaeche'])
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'minus';
                        })?.length
                    "
                    pdf-mode
                  />
                </div>
                <div class="justify-self-end">
                  <PdfChip
                    color="red"
                    mangel-amount-mode
                    :value="
                      Object?.values(getSeilzugflaecheBewertungen(ba,seilzugflaeche)['seilzugflaeche'])
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'x';
                        })?.length
                    "
                    pdf-mode
                  />
                </div>
  <!-- jfklads-->
                <div class="col-span-4 text-sm ml-1">
                  Zuwegung Seilzugfläche:
                </div>
                <span style="display: contents" >              
                  <div class="justify-self-end">
                    <PdfChip
                      color="green"
                      mangel-amount-mode
                      :value="
                        Object?.values(getSeilzugflaecheBewertungen(ba,seilzugflaeche)['zuwegungSeilzugflaeche'])
                          ?.flat(1)
                          ?.filter((f) => {
                            return f === 'plus';
                          })?.length
                      "
                      pdf-mode
                    />
                  </div>
                  <div class="justify-self-end">
                    <PdfChip
                      color="blue"
                      mangel-amount-mode
                      :value="
                        Object?.values(getSeilzugflaecheBewertungen(ba,seilzugflaeche)['zuwegungSeilzugflaeche'])
                          ?.flat(1)
                          ?.filter((f) => {
                            return f === 'o';
                          })?.length
                      "
                      pdf-mode
                    />
                  </div>
                  <div class="justify-self-end">
                    <PdfChip
                      color="yellow"
                      mangel-amount-mode
                      :value="
                        Object?.values(getSeilzugflaecheBewertungen(ba,seilzugflaeche)['zuwegungSeilzugflaeche'])
                          ?.flat(1)
                          ?.filter((f) => {
                            return f === 'minus';
                          })?.length
                      "
                      pdf-mode
                    />
                  </div>
                  <div class="justify-self-end">
                    <PdfChip
                      color="red"
                      mangel-amount-mode
                      :value="
                        Object?.values(getSeilzugflaecheBewertungen(ba,seilzugflaeche)['zuwegungSeilzugflaeche'])
                          ?.flat(1)
                          ?.filter((f) => {
                            return f === 'x';
                          })?.length
                      "
                      pdf-mode
                    />
                  </div>
                </span>   
  <!-- jfklads-->
              <div class="col-span-4 text-sm ml-1">Fläche zwischen Mast und Seilzugfläche:</div>
                <div class="justify-self-end">
                  <PdfChip
                    color="green"
                    mangel-amount-mode
                    :value="
                      Object?.values(getSeilzugflaecheBewertungen(ba,seilzugflaeche)['flaecheZwischenMastUndSeilzug'])
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'plus';
                        })?.length
                    "
                    pdf-mode
                  />
                </div>
                <div class="justify-self-end">
                  <PdfChip
                    color="blue"
                    mangel-amount-mode
                    :value="
                      Object?.values(getSeilzugflaecheBewertungen(ba,seilzugflaeche)['flaecheZwischenMastUndSeilzug'])
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'o';
                        })?.length
                    "
                    pdf-mode
                  />
                </div>
                <div class="justify-self-end">
                  <PdfChip
                    color="yellow"
                    mangel-amount-mode
                    :value="
                      Object?.values(getSeilzugflaecheBewertungen(ba,seilzugflaeche)['flaecheZwischenMastUndSeilzug'])
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'minus';
                        })?.length
                    "
                    pdf-mode
                  />
                </div>
                <div class="justify-self-end">
                  <PdfChip
                    color="red"
                    mangel-amount-mode
                    :value="
                      Object?.values(getSeilzugflaecheBewertungen(ba,seilzugflaeche)['flaecheZwischenMastUndSeilzug'])
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'x';
                        })?.length
                    "
                    pdf-mode
                  />
                </div>
              </div>
            </div>
<!-- RESULTS Schutzgerueste-->
            <div class="flex justify-between border-solid rounded-md whiteYellowBorderColor">
              <div class="text-lg md:text-lg">Schutzgerüste</div>

              <div>
                <PdfChip
                  :color="colorSchutzgerueste"
                  mangel-amount-mode
                  :value="amountSchutzgerueste"
                  big
                  pdf-mode
                />
              </div>
            </div>
            <div class="p-2 grid grid-cols-8 gap-2 w-fit" v-for="(schutzgeruest, szgKey) in getSchutzgerueste(ba)" :key="szgKey">
              <div class="col-span-2 ml-2 text-sm">Schutzgerüst {{szgKey + 1}}</div>
              <div class="place-self-center col-span-2 text-xs">
                {{ schutzgeruest.findFrageByRelativePath(ba,'ergebnisschutzgeruest')?.getSelectedAuswahlLabelsString() }}
              </div>
                <div class="justify-self-end">
                  <PdfChip
                    color="green"
                    mangel-amount-mode
                    :value="
                      Object?.values(getSchutzgeruestBewertungen(ba, schutzgeruest))
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'plus';
                        })?.length
                    "
                    pdf-mode
                  />
                </div>
                <div class="justify-self-end">
                  <PdfChip
                    color="blue"
                    mangel-amount-mode
                    :value="
                      Object?.values(getSchutzgeruestBewertungen(ba, schutzgeruest))
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'o';
                        })?.length
                    "
                    pdf-mode
                  />
                </div>
                <div class="justify-self-end">
                  <PdfChip
                    color="yellow"
                    mangel-amount-mode
                    :value="
                      Object?.values(getSchutzgeruestBewertungen(ba, schutzgeruest))
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'minus';
                        })?.length
                    "
                    pdf-mode
                  />
                </div>
                <div class="justify-self-end">
                  <PdfChip
                    color="red"
                    mangel-amount-mode
                    :value="
                      Object?.values(getSchutzgeruestBewertungen(ba, schutzgeruest))
                        ?.flat(1)
                        ?.filter((f) => {
                          return f === 'x';
                        })?.length
                    "
                    pdf-mode
                  />
                </div>
            </div>
<!-- RESULTS Fremdleitungen-->
            <div class="flex justify-between border-solid rounded-md whiteYellowBorderColor">
              <div class="text-lg md:text-lg">Fremdleitungen</div>
              <div>
                <PdfChip
                  :color="colorFremdleitung"
                  mangel-amount-mode
                  :value="amountFremdleitung"
                  big
                  pdf-mode
                />
              </div>
            </div>
            <div class="p-2 grid grid-cols-8 gap-2 w-fit">
              <div class="col-span-4 ml-2 text-sm">Fremdleitungen:</div>
              <div class="justify-self-end">
                <PdfChip
                  color="green"
                  mangel-amount-mode
                  :value="
                    Object?.values(getFremdleitungenBewertungen(ba))
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'plus';
                      })?.length
                  "
                  pdf-mode
                />
              </div>
              <div class="justify-self-end">
                <PdfChip
                  color="blue"
                  mangel-amount-mode
                  :value="
                    Object?.values(getFremdleitungenBewertungen(ba))
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'o';
                      })?.length
                  "
                  pdf-mode
                />
              </div>
              <div class="justify-self-end">
                <PdfChip
                  color="yellow"
                  mangel-amount-mode
                  :value="
                    Object?.values(getFremdleitungenBewertungen(ba))
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'minus';
                      })?.length
                  "
                  pdf-mode
                />
              </div>
              <div class="justify-self-end">
                <PdfChip
                  color="red"
                  mangel-amount-mode
                  :value="
                    Object?.values(getFremdleitungenBewertungen(ba))
                      ?.flat(1)
                      ?.filter((f) => {
                        return f === 'x';
                      })?.length
                  "
                  pdf-mode
                />
              </div>
            </div>
          </div>
        </div>
        <be-footer
          :ba="ba"
          :immobilie="immobilie"
          :lang="lang"
          class=""
        />
      </div>
    </div>
  </pdf-a4-page>
</template>


<script lang="ts">
  import useUser from '@/composables/useUser';
  import Bestandsaufnahme from '@/models/ba/Bestandsaufnahme';
  import Immobilie from '@/models/immobilie.model';
  import { defineComponent, PropType } from 'vue';
  import { useI18n } from 'vue-i18n';
  import moment from 'moment';
  import { useIdentifierFrageFinder, getAuswahlLabel, } from '@/composables/Bestandsaufnahme/useIdentifierFinder';
  import { getPhotoUrl } from '@/utilities/get-media-url';
  import PdfA4Page from '@/components/Pdf/Components/PdfA4Page.vue';
  import PdfChip from '../Components/PdfChip.vue';
  import BeFooter from './PageElements/BeFooter.vue';
  import { useGesamtflaechen } from './PageElements/useGesamtflaechen';
  import IsVorhandenCharAndLabel from './PageElements/isVorhandenCharAndLabel.vue';
  export default defineComponent({
    name: 'CoverPage',
    components: {
      PdfA4Page,
      PdfChip,
      BeFooter,
      IsVorhandenCharAndLabel
    },
    props: {
      ba: {
        type: Object as PropType<Bestandsaufnahme>,
        required: true,
      },
      immobilie: {
        type: Object as PropType<Immobilie>,
        required: true,
      },
      lang: {
        type: String,
        default: 'de',
      },
    },
    setup(props: any) {
      const { t } = useI18n({ useScope: 'global' });
      const uUser = useUser();
      const {
        getZuwegungBewertungen,
        getArbeitsFlaecheBewertungen,
        getFremdleitungenBewertungen,
        summarizeFremdleitungenBewertung,
        summarizeZuwegungBewertung,
        summarizeArbeitsFlaechenBewertung,
        summarizeOverall,
        getSeilzugflaechen,
        getSeilzugflaechenWrappers,
        getSchutzgerueste,
        getSchutzgeruestBewertungen,
        getSchutzgeruesteBewertungen,
        summarizeSeilzugflaecheBewertungen,
        summarizeSchutzgeruesteBewertung,
        getSeilzugflaecheBewertungen,
        summarizeOverallSeilzugflaechen,
      } = useGesamtflaechen();

      return {
        user: uUser.user,
        t,
        useIdentifierFrageFinder,
        moment,
        getPhotoUrl,
        getZuwegungBewertungen,
        getArbeitsFlaecheBewertungen,
        getFremdleitungenBewertungen,
        getSchutzgeruestBewertungen,
        getSchutzgerueste,
        amountSchutzgerueste: summarizeSchutzgeruesteBewertung(props.ba)['amount'],
        colorSchutzgerueste: summarizeSchutzgeruesteBewertung(props.ba)['color'],
        amountFremdleitung: summarizeFremdleitungenBewertung(props.ba)['amount'],
        colorFremdleitung: summarizeFremdleitungenBewertung(props.ba)['color'],
        amountZuwegung: summarizeZuwegungBewertung(props.ba)['amount'],
        colorZuwegung: summarizeZuwegungBewertung(props.ba)['color'],
        amountArbeitsFlaechen: summarizeArbeitsFlaechenBewertung(props.ba)[
          'amount'
        ],
        colorArbeitsFlaechen: summarizeArbeitsFlaechenBewertung(props.ba)[
          'color'
        ],
        amountOverall: summarizeOverall(props.ba)['amount'],
        colorOverall: summarizeOverall(props.ba)['color'],
        getAuswahlLabel,
        getSeilzugflaechenWrappers,
        getSeilzugflaechen,
        getSeilzugflaecheBewertungen,
        summarizeSeilzugflaecheBewertungen,
        summarizeOverallSeilzugflaechen,
      };
    },
    computed: {
      statusReadable() {
        switch (this.ba.status) {
          case 'ABGESCHLOSSEN':
            return 'Abgeschlossen';
          case 'ANGELEGT':
            return 'Angelegt';
          case 'GEPLANT':
            return 'Geplant';
          case 'IN_DURCHFUEHRUNG':
            return 'In Durchführung'; 
          case 'FREIGEGEBEN':
            return 'Freigegeben';  
          case 'ARCHIVIERT':
            return 'Archiviert';
          default:
            return this.ba.status;
        }
      }
    }
  });
</script>

<style scoped>
  * {
    color: rgb(23, 68, 81);
    font-family: var(--secondaryFont);
  }
  .pdf-content {
    width: 800px;
    margin: 0 auto;
    color: var(--white100);
  }
  .landingpage-background {
    position: absolute;
    top: 50px;
    left: 50px;
    width: 700px;
    height: 1050px;
    color: var(--black100);
  }
  .trenner {
    height: 1px;
    border-width: 0;
    color: gray;
    background-color: gray;
  }
  .content {
    height: 800px;
  }
</style>